<script>
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { _ } from 'svelte-i18n';
    import { next, previous, goto, replace } from '../helpers/navigation.svelte.js';
    import { fetchApi } from '../helpers/api.svelte.js';

    import Section from '../components/Section.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';
    import Back from '../components/Back.svelte';
    import Loader from '../components/Loader.svelte';
    import List from '../components/Employees/List.svelte';
    import Generic from '../components/Employees/Generic.svelte';

    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';


    const current = 'employee';

    function goBack() {
        currentSession.employee = null;

        replace(previous(current), 'left');
    }

    function goNext(id) {
        if (id) {
            currentSession.employee = employees.find(employee => employee.id === id);
        }
        else {
            currentSession.employee = { ...generic };
        }

        goto(next(current), 'right');
    }


    let employees = $state([]);
    let generic = $state({});

    async function getEmployees() {
        const form = new FormData();
        form.append('session', currentSessionId);
        form.append('client', currentSession.client);
        form.append('salon', currentSession.salon);

        let command = 'get';

        // Only filter by treatment if stepsOrder is 'treatment,employee' OR origin is Google Reserve
        // (Google Reserve forces treatment first, so we always filter by treatment when it's the origin)

        if (app.settings.stepsOrder === 'treatment,employee' || currentSession.origin === 'google-reserve') {
            command = 'getForTreatment';
            form.append('treatment', currentSession.treatment?.id);
        }

        const data = await fetchApi({ 
            endpoint: `OnlineAppointment.Remote.Employees/${command}`, 
            data: form 
        });

        employees = data.employees.filter(e => e.type == 'employee');
        generic = data.employees.find(e => e.type == 'any');
	}

</script>

<svelte:head>
    <title>{$_('appointment_title')} - {$_('employee')}</title>
</svelte:head>

<Section title={$_('employee')}>
    {#snippet back()}
        <Back onclick={goBack} />
    {/snippet}
    
    {#await getEmployees()}
        <Loader />
    {:then}
        <p>{$_('employee_preference')}</p>

        {#if generic}
            <Generic item={generic} onSelect={goNext} />            

            <p>{$_('if_yes_choose_employee')}</p>
        {/if}

        <List items={employees} onSelect={goNext} />
    {/await}
</Section>